import Image from "next/image";
import React from "react";
import { useTranslations } from '../../locales/useTranslations';
import { BiLineChart, BiData, BiTrendingUp, BiTargetLock, BiCog } from "react-icons/bi";
import FadeInAnimation from '../Common/FadeInAnimation';

const BusinessAnalyticsDatenAlsRessource = () => {
  const { t } = useTranslations();

  const features = [
    { icon: BiLineChart, text: t("businessAnalytics_dataAsResource_feature1") },
    { icon: BiData, text: t("businessAnalytics_dataAsResource_feature2") },
    { icon: BiTrendingUp, text: t("businessAnalytics_dataAsResource_feature3") },
    { icon: BiTargetLock, text: t("businessAnalytics_dataAsResource_feature4") },
    { icon: BiCog, text: t("businessAnalytics_dataAsResource_feature5") },
  ];

  return (
    <section className="ba-data-resource">
      {/* Hintergrund-Dekorationen */}
      <div className="ba-data-resource__decoration ba-data-resource__decoration--1"></div>
      <div className="ba-data-resource__decoration ba-data-resource__decoration--2"></div>

      <div className="container">
        <div className="row align-items-center">
          {/* Text-Bereich */}
          <div className="col-lg-6 order-2 order-lg-1">
            <FadeInAnimation direction="left" delay={100}>
              <div className="ba-data-resource__content">
                <span className="ba-data-resource__badge">
                  {t("businessAnalytics_dataAsResource_subtitle")}
                </span>

                <h2 className="ba-data-resource__title">
                  {t("businessAnalytics_dataAsResource_title")}
                  <span className="ba-data-resource__title-accent"></span>
                </h2>

                <p className="ba-data-resource__description">
                  {t("businessAnalytics_dataAsResource_description")}
                </p>

                <div className="ba-data-resource__features">
                  {features.map((feature, index) => (
                    <FadeInAnimation key={index} direction="up" delay={150 + index * 50}>
                      <div className="ba-data-resource__feature">
                        <div className="ba-data-resource__feature-icon">
                          <feature.icon />
                        </div>
                        <span className="ba-data-resource__feature-text">{feature.text}</span>
                      </div>
                    </FadeInAnimation>
                  ))}
                </div>

                <p className="ba-data-resource__description ba-data-resource__description--secondary">
                  {t("businessAnalytics_dataAsResource_description2")}
                </p>
              </div>
            </FadeInAnimation>
          </div>

          {/* Bild-Bereich */}
          <div className="col-lg-6 order-1 order-lg-2">
            <FadeInAnimation direction="right" delay={200}>
              <div className="ba-data-resource__visual">
                <div className="ba-data-resource__image-container">
                  <div className="ba-data-resource__image-frame">
                    <Image
                      src="/images/business-analytics/banner-bg3.webp"
                      alt="Simplify Data - Datenanalyse"
                      width={600}
                      height={500}
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                </div>
              </div>
            </FadeInAnimation>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BusinessAnalyticsDatenAlsRessource;
